export type EprintPrintOption = {
  id: string
  type: string
  side: string
  size: string
  count: string
  isRecommended?: boolean
}

export type EprintTemplateConfig = {
  recommended: string
  recommendedText?: string
  options: EprintPrintOption[]
}

const CASHLESS_TYPE_IDS = ['1', '4', '6', '7', '8', '15']

const SEVEN_ELEVEN_500_FLAGS = [
  'nophotolong',
  'letter',
  'taishokutodoke',
  'keireki',
  'shiboudoukisho'
]

export function getOptionLabel(option: EprintPrintOption): string {
  return option.type === 'color' ? 'カラー' + option.side : '白黒' + option.side
}

export function getOptionClass(option: EprintPrintOption): string {
  const typeClass =
    option.type === 'color'
      ? 'eprint-list-radio--color'
      : 'eprint-list-radio--mono'
  return `eprint-list-radio ${typeClass}`
}

export function isCashlessSupported(
  option: { id?: string } | null | undefined
): boolean {
  return !!option && CASHLESS_TYPE_IDS.includes(String(option.id))
}

export function selectedStyle(printType: string, id: string): string {
  if (id === printType) return 'border-color:#E3165C;'
  return ''
}

export function getSevenElevenPriceMemo(printFlag: string): string {
  if (SEVEN_ELEVEN_500_FLAGS.indexOf(printFlag) >= 0) {
    return '※セブンイレブンで印刷する場合は、500円になります。'
  }
  return '※セブンイレブンで印刷する場合は、700円になります。'
}
